import { indexItems } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            内容导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            按分类快速浏览水果视频平台的海量影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-start gap-3 p-5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors text-sm">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}